import React from "react";

import { Link, Typography as MuiTypography } from "@mui/material";
import clsx from "clsx";

import { TypographyProps } from "./base/types";
import { useTypographyStyles } from "./base/useTypographyStyles";

export const CaptionHyperlink: React.FC<TypographyProps> = ({
  text,
  href,
  onClick,
  ...props
}) => {
  const { classes } = useTypographyStyles();

  return (
    <Link href={href} onClick={onClick} underline="none">
      <MuiTypography
        className={clsx(classes.textRegular, classes.caption)}
        {...props}
      >
        {text}
      </MuiTypography>
    </Link>
  );
};
